// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.accordion-graphics-container {
  padding: 16px;
  border-radius: 8px;
  border: 1px solid var(--sebrae-light-gray4);
  position: relative;
}
.accordion-graphics-container .header-accordion {
  width: 100%;
  border: none;
  padding: 0;
  cursor: pointer;
  border-radius: 4px;
}
.accordion-graphics-container .header-accordion .header-content {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.accordion-graphics-container .header-accordion .header-content img {
  width: 12px;
  transition: transform 0.3s ease;
}
.accordion-graphics-container .header-accordion .header-content img.rotate-down {
  transform: rotate(180deg);
}
.accordion-graphics-container .header-accordion .header-content img.rotate-up {
  transform: rotate(0deg);
}
.accordion-graphics-container .header-accordion .header-content-left {
  gap: 8px;
  display: flex;
  font-weight: 700;
  padding-right: 11px;
  align-items: center;
  color: var(--sebrae-blue-6);
}
.accordion-graphics-container .header-accordion .header-content-left p {
  font-weight: 700;
  max-width: 570px;
  text-align: left;
  margin: 0 !important;
  font-size: 27px;
  color: var(--sebrae-blue-6);
}
.accordion-graphics-container .header-accordion .header-content-left img {
  width: 15px;
  height: 15px;
}
.accordion-graphics-container .panel {
  display: grid;
  grid-template-rows: 0fr;
  transition: grid-template-rows 0.3s ease, margin-top 0.3s ease;
  margin-top: 0;
}
.accordion-graphics-container .panel.open {
  margin-top: 10px;
  grid-template-rows: 1fr;
}
.accordion-graphics-container .panel .panel-content {
  overflow: hidden;
  min-height: 0;
}
.accordion-graphics-container .panel .example {
  padding: 0 16px 16px;
  font-size: 13px;
}
.accordion-graphics-container .panel .example img {
  margin-bottom: 10px;
}
.accordion-graphics-container .panel .example span {
  font-weight: 700;
}
.accordion-graphics-container .panel .example.first {
  margin-bottom: 24px;
}
.accordion-graphics-container .panel .example .example-list {
  list-style-type: disc;
  padding-left: 20px;
  margin-top: 8px;
}
.accordion-graphics-container .panel .example .example-list li {
  line-height: 1.2;
}
.accordion-graphics-container .panel .example .example-list li strong {
  font-weight: 600;
}
.accordion-graphics-container .panel.open .panel-content {
  overflow: visible;
}
@media (min-width: 1024px) {
  .accordion-graphics-container .header-accordion .header-content-left p {
    font-size: 16px;
  }
  .accordion-graphics-container .panel .example {
    gap: 8px;
    display: flex;
  }
  .accordion-graphics-container .panel .example img {
    width: auto;
    height: 18px;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/accordion-graphics/index.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,kBAAA;EACA,2CAAA;EACA,kBAAA;AACF;AACE;EACE,WAAA;EACA,YAAA;EACA,UAAA;EACA,eAAA;EACA,kBAAA;AACJ;AACI;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;AACN;AACM;EACE,WAAA;EACA,+BAAA;AACR;AACQ;EACE,yBAAA;AACV;AAEQ;EACE,uBAAA;AAAV;AAIM;EACE,QAAA;EACA,aAAA;EACA,gBAAA;EACA,mBAAA;EACA,mBAAA;EACA,2BAAA;AAFR;AAIQ;EACE,gBAAA;EACA,gBAAA;EACA,gBAAA;EACA,oBAAA;EACA,eAAA;EACA,2BAAA;AAFV;AAKQ;EACE,WAAA;EACA,YAAA;AAHV;AASE;EACE,aAAA;EACA,uBAAA;EACA,8DAAA;EACA,aAAA;AAPJ;AASI;EACE,gBAAA;EACA,uBAAA;AAPN;AAUI;EACE,gBAAA;EACA,aAAA;AARN;AAWI;EACE,oBAAA;EACA,eAAA;AATN;AAWM;EACE,mBAAA;AATR;AAYM;EACE,gBAAA;AAVR;AAaM;EACE,mBAAA;AAXR;AAcM;EACE,qBAAA;EACA,kBAAA;EACA,eAAA;AAZR;AAcQ;EACE,gBAAA;AAZV;AAcU;EACE,gBAAA;AAZZ;AAoBI;EACE,iBAAA;AAlBN;AAsBE;EAIQ;IACE,eAAA;EAvBV;EA8BI;IACE,QAAA;IACA,aAAA;EA5BN;EA8BM;IACE,WAAA;IACA,YAAA;EA5BR;AACF","sourcesContent":[".accordion-graphics-container {\n  padding: 16px;\n  border-radius: 8px;\n  border: 1px solid var(--sebrae-light-gray4);\n  position: relative;\n\n  .header-accordion {\n    width: 100%;\n    border: none;\n    padding: 0;\n    cursor: pointer;\n    border-radius: 4px;\n\n    .header-content {\n      display: flex;\n      align-items: center;\n      justify-content: space-between;\n\n      img {\n        width: 12px;\n        transition: transform 0.3s ease;\n\n        &.rotate-down {\n          transform: rotate(180deg);\n        }\n\n        &.rotate-up {\n          transform: rotate(0deg);\n        }\n      }\n\n      &-left {\n        gap: 8px;\n        display: flex;\n        font-weight: 700;\n        padding-right: 11px;\n        align-items: center;\n        color: var(--sebrae-blue-6);\n\n        p {\n          font-weight: 700;\n          max-width: 570px;\n          text-align: left;\n          margin: 0 !important;\n          font-size: 27px;\n          color: var(--sebrae-blue-6);\n        }\n\n        img {\n          width: 15px;\n          height: 15px;\n        }\n      }\n    }\n  }\n\n  .panel {\n    display: grid;\n    grid-template-rows: 0fr;\n    transition: grid-template-rows 0.3s ease, margin-top 0.3s ease;\n    margin-top: 0;\n\n    &.open {\n      margin-top: 10px;\n      grid-template-rows: 1fr;\n    }\n    \n    .panel-content {\n      overflow: hidden;\n      min-height: 0;\n    }\n\n    .example {\n      padding: 0 16px 16px;\n      font-size: 13px;\n\n      img {\n        margin-bottom: 10px;\n      }\n\n      span {\n        font-weight: 700;\n      }\n\n      &.first {\n        margin-bottom: 24px;\n      }\n\n      .example-list {\n        list-style-type: disc;\n        padding-left: 20px;\n        margin-top: 8px;\n\n        li {\n          line-height: 1.2;\n\n          strong {\n            font-weight: 600;\n          }\n        }\n      }\n    }\n  }\n\n  .panel.open {\n    .panel-content {\n      overflow: visible;\n    }\n  }\n\n  @media (min-width: 1024px) {\n    .header-accordion {\n      .header-content {\n        &-left {\n          p {\n            font-size: 16px;\n          }\n        }\n      }\n    }\n\n    .panel {\n      .example {\n        gap: 8px;\n        display: flex;\n\n        img {\n          width: auto;\n          height: 18px;\n        }\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
